import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { AspectRatio, Badge, Button, HStack, Heading, Image, Stack, VStack } from '@chakra-ui/react';
import { ChevronRightIcon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { gql } from '@src/lib/gql';
import React from 'react';
import { MdNewReleases } from 'react-icons/md';
type PodcastHeroCardProps = {
  title?: string;
  megaphoneLink?: string;
  transistorLink?: string;
  posterImage?: string;
  number?: any;
  latest?: boolean;
  url?: string;
  description?: string;
};

/**
 * The Podcast PodcastHeroCard displays the latest episode in a large format as featured content.
 */
export const PodcastHeroCard: React.FC<PodcastHeroCardProps> = props => {
  const $ = _c(58);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query {
        podcastEpisodes(first: 1, orderBy: releaseDate_DESC) {
          id
          title
          description
          slug
          number
          posterImage {
            id
            url
            altText
            height
            width
          }
        }
      }
    `;
    t1 = {
      variables: {}
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const query = useQuery(t0, t1);
  query.data?.podcastEpisodes[0];
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue([10, 10, 10, 10]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== getBreakpointValue) {
    t3 = getBreakpointValue([10, 10, 10]);
    $[4] = getBreakpointValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== getBreakpointValue) {
    t4 = getBreakpointValue([10, 10, 10, 20]);
    $[6] = getBreakpointValue;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== getBreakpointValue) {
    t5 = getBreakpointValue([10, 10, 10, 20]);
    $[8] = getBreakpointValue;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `linear-gradient(180deg, #1A1B2090, #1A1B20), url(${props.posterImage}) center center/cover no-repeat`;
  const t7 = `linear-gradient(180deg, #1A1B2090, #1A1B20), url(${props.posterImage}) center center/cover no-repeat`;
  let t8;
  if ($[10] !== getBreakpointValue || $[11] !== t6 || $[12] !== t7) {
    t8 = getBreakpointValue([t6, t7, "transparent"]);
    $[10] = getBreakpointValue;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== getBreakpointValue) {
    t9 = getBreakpointValue(["center", "center", "flex-start"]);
    $[14] = getBreakpointValue;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== getBreakpointValue) {
    t10 = getBreakpointValue(["center", "center", "space-between"]);
    $[16] = getBreakpointValue;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Badge size="sm" variant="subtle"><MdNewReleases />Latest Episode</Badge>;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== getBreakpointValue) {
    t12 = getBreakpointValue(["3xl", "3xl", "3xl", "4xl"]);
    $[19] = getBreakpointValue;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== getBreakpointValue) {
    t13 = getBreakpointValue(["center", "center", "left"]);
    $[21] = getBreakpointValue;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== props.title || $[24] !== t12 || $[25] !== t13) {
    t14 = <Heading as="h1" size={t12} textAlign={t13}>{props.title}</Heading>;
    $[23] = props.title;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const t15 = props.url || "#";
  let t16;
  if ($[27] !== getBreakpointValue) {
    t16 = getBreakpointValue(["md", "md", "md"]);
    $[27] = getBreakpointValue;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <ChevronRightIcon />;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t16) {
    t18 = <Button as="span" bgColor="actionActiveSecondary" size={t16}>{"Listen & Discuss"}{t17}</Button>;
    $[30] = t16;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t15 || $[33] !== t18) {
    t19 = <NextLink href={t15} prefetch={false}>{t18}</NextLink>;
    $[32] = t15;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t10 || $[36] !== t14 || $[37] !== t19 || $[38] !== t9) {
    t20 = <VStack align={t9} flex={2} gap={6} justify={t10} zIndex={2}>{t11}{t14}{t19}</VStack>;
    $[35] = t10;
    $[36] = t14;
    $[37] = t19;
    $[38] = t9;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== getBreakpointValue) {
    t21 = getBreakpointValue([true, true, false]);
    $[40] = getBreakpointValue;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== props.posterImage || $[43] !== props.title) {
    t22 = <Image alt={props.title} src={props.posterImage} />;
    $[42] = props.posterImage;
    $[43] = props.title;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t21 || $[46] !== t22) {
    t23 = <AspectRatio borderRadius="2xl" boxShadow="sm" flex={2} hidden={t21} overflow="hidden" ratio={1.7777777777777777}>{t22}</AspectRatio>;
    $[45] = t21;
    $[46] = t22;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t20 || $[49] !== t23) {
    t24 = <HStack align="center" gap={20} width="full">{t20}{t23}</HStack>;
    $[48] = t20;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t2 || $[52] !== t24 || $[53] !== t3 || $[54] !== t4 || $[55] !== t5 || $[56] !== t8) {
    t25 = <Stack direction="column" gap={t2} height="full" justify="center" paddingBottom={t3} paddingTop={t4} paddingX={t5} position="relative" background={t8}>{t24}</Stack>;
    $[51] = t2;
    $[52] = t24;
    $[53] = t3;
    $[54] = t4;
    $[55] = t5;
    $[56] = t8;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  return t25;
};